import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'components/admin/general-contractors/GeneralContractors.css';
import SearchBar from 'components/shared/navigation/SearchBar';
import NavigationBar from 'components/shared/navigation/NavigationBar';
import {
  getCurrentPage,
  getGeneralContractors,
} from 'components/admin/general-contractors/store/selectors';
import {
  loadGeneralContractorsRequest,
  addGeneralContractor,
  showGeneralContractorDetails,
} from 'components/admin/general-contractors/store/actions';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import { simpleScrollToTop } from 'services/utils/scroller-util';
import GeneralContractorsTable from 'components/admin/general-contractors/GeneralContractorsTable';

export class GeneralContractor extends Component {
  tabSelection = 1;

  componentDidMount() {
    this.props.dispatch(loadGeneralContractorsRequest(1));
  }

  componentDidUpdate() {
    simpleScrollToTop();
  }

  handleNavSelect = (id) => {
    this.tabSelection = id;
    this.loadGeneralContractors(id, 1);
  };

  handlePageChange = (newPage) => {
    this.loadGeneralContractors(this.tabSelection, newPage);
  };

  loadGeneralContractors(tabSelection, newPage) {
    switch (tabSelection) {
      case 1:
        this.props.dispatch(loadGeneralContractorsRequest(newPage));
        break;

      case 2:
        this.props.dispatch(loadGeneralContractorsRequest(newPage, 'active'));
        break;

      case 3:
        this.props.dispatch(loadGeneralContractorsRequest(newPage, 'inactive'));
        break;

      default:
    }
  }

  handleAddGeneralContractors = () => {
    this.props.dispatch(addGeneralContractor());
  };

  handleRowGeneralContractors = (index) => {
    const generalContractorId = this.props.generalContractors.data[index].id;
    this.props.dispatch(showGeneralContractorDetails(generalContractorId));
  };

  handleGenerateLink = (index) => {
    const {
      generalContractors: { data },
    } = this.props;
    return `general-contractors/${data[index].id}`;
  };

  render() {
    const { generalContractors } = this.props;
    return (
      <div className="general-contractors">
        <div className="full-title">General Contractors</div>

        {
          <div className="content-container">
            <SearchBar
              addButton={
                <input
                  className={'btn button button-orange'}
                  type="button"
                  value="Add GC"
                  onClick={this.handleAddGeneralContractors}
                />
              }
            >
              <NavigationBar
                items={[
                  {
                    id: 1,
                    show: true,
                    title: 'All',
                  },
                  {
                    id: 2,
                    show: generalContractors.totalActive > 0,
                    title: 'Active',
                    total: generalContractors.totalActive,
                  },
                  {
                    id: 3,
                    show: generalContractors.totalInactive > 0,
                    title: 'Pending invites',
                    total: generalContractors.totalInactive,
                  },
                ]}
                onSelected={this.handleNavSelect}
              />
            </SearchBar>

            <GeneralContractorsTable
              generalContractors={this.props.generalContractors.data}
              onRowSelected={this.handleRowGeneralContractors}
              onGenerateLink={this.handleGenerateLink}
            />

            <div className="pagination-container">
              <SimplePagination
                currentPage={this.props.currentPage}
                pageSize={generalContractors.pageSize}
                total={generalContractors.total}
                onPageChange={this.handlePageChange}
              />
            </div>
          </div>
        }
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentPage: getCurrentPage(state),
    generalContractors: getGeneralContractors(state),
  };
})(GeneralContractor);



// WEBPACK FOOTER //
// ./src/components/admin/general-contractors/GeneralContractors.js